import { BorderBox, Box, Position } from '@trmediaab/zebra';

import { useModalContext } from '../../utils/useModalContext';

interface OuterContainerProps {
  children: React.ReactNode;
  variant: 'narrow' | 'wide' | 'none';
}

const OuterContainer = ({ children, variant }: OuterContainerProps) => {
  const modalId = useModalContext();

  const content = (
    <Box width="100%" maxWidth="checkout.innerMaxWidth" mx="auto">
      {children}
    </Box>
  );

  return (
    <>
      <Position.relative id={modalId} />
      {variant === 'narrow' && (
        <BorderBox
          bg="checkout.containerBg"
          border="1"
          p={{ _: 3, lg: 4 }}
          maxWidth="480px"
          mx="auto"
        >
          {content}
        </BorderBox>
      )}

      {variant === 'wide' && (
        <BorderBox
          border="1"
          borderColor="checkout.containerBorder"
          bg="checkout.containerBg"
          boxShadow="checkout.box"
          maxWidth="940px"
          width="100%"
          px={[3, 4, null, 5]}
          py={[3, 4, null, 5]}
          mx="auto"
        >
          {content}
        </BorderBox>
      )}

      {variant === 'none' && <>{content}</>}
    </>
  );
};

export default OuterContainer;
